import { useCallback, useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function AuditTabNav({ tabs, activeTab, onTabChange }) {
  const navRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const updateScrollHints = useCallback(() => {
    const el = navRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 4);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
  }, []);

  useEffect(() => {
    updateScrollHints();
    const timer = setTimeout(updateScrollHints, 150);
    const el = navRef.current;
    if (!el) return undefined;
    el.addEventListener("scroll", updateScrollHints, { passive: true });
    window.addEventListener("resize", updateScrollHints);
    return () => {
      clearTimeout(timer);
      el.removeEventListener("scroll", updateScrollHints);
      window.removeEventListener("resize", updateScrollHints);
    };
  }, [tabs, updateScrollHints]);

  const scrollBy = (direction) => {
    navRef.current?.scrollBy({ left: direction * 180, behavior: "smooth" });
  };

  return (
    <div className="audit-tab-nav-wrap">
      <button
        type="button"
        className={`audit-tab-scroll left ${canScrollLeft ? "visible" : ""}`}
        onClick={() => scrollBy(-1)}
        aria-label="Scroll tabs left"
        tabIndex={canScrollLeft ? 0 : -1}
      >
        <ChevronLeft size={16} />
      </button>
      <div className="audit-tab-nav" ref={navRef}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`audit-tab-btn ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <button
        type="button"
        className={`audit-tab-scroll right ${canScrollRight ? "visible" : ""}`}
        onClick={() => scrollBy(1)}
        aria-label="Scroll tabs right"
        tabIndex={canScrollRight ? 0 : -1}
      >
        <ChevronRight size={16} />
      </button>
    </div>
  );
}
